/**
 * NewUseCasesPage — 20260605 Figma redesign, mounted at /ivt/impact.
 * The legacy Pipeline Map + UC Catalog page at /ivt/use-cases is unchanged.
 *
 * The chat panel defaults to expanded elsewhere in the portal, but the Impact
 * page's chart + filter row + PropertyFilter tokens already fill the width;
 * a right-side chat panel would compress the chart. So it starts collapsed
 * (user-requested 2026-08-03) — the user can re-open it via its toolbar toggle.
 * That is no longer done here: `/ivt/impact` is listed in FULL_WIDTH_ROUTES and
 * ChatShell applies it, so the same policy is not implemented twice.
 */

import PageHeader from '../../../components/PageHeader/PageHeader';
import IndustryPipelineOverview from './components/IndustryPipelineOverview';
import './UseCasesPage.css';

export default function NewUseCasesPage() {
  return (
    <div className="ivt-usecases-page">
      <PageHeader title="Impact" />
      <div className="ivt-usecases-page__body ivt-usecases-page__body--new">
        <IndustryPipelineOverview />
      </div>
    </div>
  );
}
